import Svg, { Path } from 'react-native-svg'

const GameControl = () => {
  return (
    <Svg width={64} height={64} viewBox="0 0 64 64">
      <Path d="M32 0A32 32 0 110 32 32 32 0 0132 0z" fill="#0070b6" opacity={0.996} />
      <Path
        d="M26.341 42.337l2.83-2.816 2.831 2.816 2.834-2.816 2.831 2.816-5.665 5.666zm13.183-7.5l2.814-2.834-2.814-2.834 2.814-2.828 5.664 5.662-5.666 5.659zm-23.522-2.834l5.664-5.663 2.816 2.829-2.816 2.834 2.816 2.831-2.816 2.828zm12.569 0a3.428 3.428 0 113.431 3.428 3.431 3.431 0 01-3.431-3.428zm3.431-10.338l-2.831 2.816-2.83-2.816 5.661-5.662 5.666 5.662-2.835 2.816z"
        fill="#fff"
      />
    </Svg>
  )
}

export { GameControl }
